// extracted by mini-css-extract-plugin
export default {"pageholder":"SeenCar_pageholder__ZIUXR"};